import { Toggle } from '@contrast-security-inc/design-system-inputs'
import { css } from '@emotion/css'
import React, { useRef, useState } from 'react'
import { ContrastProduct } from '../shared'
import { ServerProductConfigPopover } from '../server-product-config-popover/server-product-config-popover'
import { IconInformation } from '@contrast-security-inc/design-system-foundations'
import { IconButton } from '@contrast-security-inc/design-system-buttons'

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {}

export const ServerOverviewToggle = ({
  checked,
  disabled,
  onChange,
  product,
  blocked,
  propertyName,
  propertyLocation
}: {
  checked: boolean
  disabled: boolean
  product: ContrastProduct
  onChange?: () => void
  propertyName: string
  propertyLocation: string
  blocked: boolean
}) => {
  const [showPopover, setShowPopover] = useState(false)

  const referenceElement = useRef<HTMLButtonElement | null>(null)

  const isDisabled = disabled || blocked

  const onChangeFn = !!onChange ? onChange : noop

  const toggle = (
    <Toggle
      testId="product-toggle"
      isChecked={checked}
      isDisabled={isDisabled}
      onChange={onChangeFn}
    />
  )

  return (
    <>
      <div
        className={css`
          display: flex;
          flex-direction: row;
        `}
      >
        {blocked && (
          <span
            className={css`
              margin-right: 4px;
              margin-top: 2px;
            `}
          >
            <IconButton
              ref={referenceElement}
              testId="product-toggle-disabled"
              aria-label="toggle disabled icon button"
              Icon={IconInformation}
              onClick={() => setShowPopover(true)}
              variant="secondary"
              size="md"
            ></IconButton>
          </span>
        )}

        {toggle}
      </div>
      {showPopover && (
        <ServerProductConfigPopover
          product={product}
          isProductOn={checked}
          propertyName={propertyName}
          propertyLocation={propertyLocation}
          referenceElement={referenceElement}
          onClose={() => setShowPopover(false)}
        />
      )}
    </>
  )
}
